import React from 'react';

import Result from '@/pages/headhunters/[orgId]/_lib/Result';

const UpdateResult = (props) => {
  return <Result {...props} />;
};

export default UpdateResult;
